import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';

import { PropertyService } from '../../services/property.service';
import { NavigationContextService } from '../../services/navigation-context.service';

@Component({
  selector: 'app-message-respond',
  templateUrl: './message-respond.component.html',
  styleUrls: ['./message-respond.component.scss']
})
export class MessageRespondComponent implements OnInit {
  property: any;
  conversation: any;

  constructor(@Optional() public dialogRef: MatDialogRef<MessageRespondComponent>,
              @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              private propertyService: PropertyService,
              private route: ActivatedRoute,
              private router: Router,
              private navContext: NavigationContextService) { }

  ngOnInit() {
    if (this.data && this.data.property && this.data.conversation) {
      this.property = this.data.property;
      this.conversation = this.data.conversation;
    } else {
      const propertyId = this.route.snapshot.queryParamMap.get('propertyId');
      const conversationId = this.route.snapshot.queryParamMap.get('conversationId');
      if (propertyId && conversationId) {
        this.propertyService.getPublicProperty(propertyId).then(p => {
          this.property = p;
          this.propertyService.getConversations(this.property).subscribe(convs => {
            if (Array.isArray(convs)) {
              this.conversation = convs.find(c => c.id == conversationId);
            }
          });
        });
      }
    }
  }

  onCancel() {
    this.returnToMessages();
  }

  onSend() {
    this.returnToMessages();
  }

  close() {
    this.returnToMessages();
  }

  private returnToMessages() {
    if (this.dialogRef) {
      this.dialogRef.close();
      return;
    }
    const propertyId = (this.property && this.property.id)
      || this.route.snapshot.queryParamMap.get('propertyId')
      || this.navContext.propertyId;
    this.navContext.goToMessages(propertyId);
  }
}
